import { Frame, Separator, SpacerVertical } from '@klarna/bubble-ui';
import { useResponsiveContext } from '@klarna/mp-ui';
import { AddOriginModal } from '@merchant-portal/credentials';
import React from 'react';
import { useClientId } from '../../../hooks/useClientId';
import { useMid } from '../../../hooks/useMid';
import DesktopContent from './DesktopContent';
import MobileContent from './MobileContent';
export default function ClientIdInstructions() {
    const { selectedMid } = useMid();
    const { isAddOriginModalVisible, onAddOriginSuccess, setIsAddOriginModalVisible } = useClientId();
    const { isMobile } = useResponsiveContext();
    return (React.createElement(Frame, { paddingToken: 'space.0' },
        isMobile ? React.createElement(MobileContent, null) : React.createElement(DesktopContent, null),
        React.createElement(SpacerVertical, { spaceToken: 'space.400' }),
        selectedMid &&
            React.createElement(AddOriginModal, { mid: selectedMid, onSuccess: onAddOriginSuccess, isVisible: isAddOriginModalVisible, setIsVisible: setIsAddOriginModalVisible }),
        React.createElement(Separator, { colorToken: "colors/backgrounds/subtle-floating" })));
}
